/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface DashboardStats {
  readonly revenuePaise: number;
  readonly revenueTrendPct: number | null;
  readonly activeClients: number;
  readonly activeClientsTrendPct: number | null;
  readonly sessionsThisMonth: number;
  readonly sessionsTrendPct: number | null;
  readonly avgSatisfactionPct: number | null;
  readonly satisfactionTrendPct: number | null;
  readonly therapistsTotal: number;
  readonly therapistsOnRoll: number;
  readonly therapistsConsultant: number;
  readonly todaySessions: number;
  readonly todayCompleted: number;
  readonly todayInProgress: number;
  readonly overduePaise: number;
}

export interface MonthlyPoint {
  readonly monthIso: string;
  readonly revenuePaise: number;
  readonly sessions: number;
}

export interface DistributionSlice {
  readonly label: string;
  readonly count: number;
}

export interface TherapistPerf {
  readonly id: string;
  readonly name: string;
  readonly sessions: number;
  readonly satisfactionPct: number | null;
  readonly revenuePaise: number;
}

export interface UpcomingSession {
  readonly id: string;
  readonly clientName: string;
  readonly therapistName: string | null;
  readonly sessionType: string | null;
  readonly startIso: string;
}

export interface ActivityItem {
  readonly id: string;
  readonly action: string;
  readonly actorName: string | null;
  readonly entity: string | null;
  readonly occurredAt: string;
}

export interface AdminDashboard {
  readonly stats: DashboardStats;
  readonly monthly: readonly MonthlyPoint[];
  readonly distribution: readonly DistributionSlice[];
  readonly therapistPerformance: readonly TherapistPerf[];
  readonly upcomingToday: readonly UpcomingSession[];
  readonly recentActivity: readonly ActivityItem[];
}

export const dashboardApi = {
  async admin(): Promise<AdminDashboard> {
    const { data } = await apiClient.get<AdminDashboard>('/admin/dashboard');
    return data;
  },
};
